export const narAppStorageKey = 'unidas-nar-token';
export const narAppADEnabledKey = 'unidas-nar-ad';
